// extracted by mini-css-extract-plugin
module.exports = {"card":"style-module--card--3v8ar","image":"style-module--image--3XHKo","textArea":"style-module--textArea--14UNZ","boldText":"style-module--boldText--2DBVa"};